import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

const EndorsementsPage = lazy(() =>import('../../../pages/').then((module) => ({ default: module.EndorsementsPage })));
const TransportsPage = lazy(() =>import('../../../pages/').then((module) => ({ default: module.TransportsPage })));

export const emissionChildrenRoutes = [
  {
    path: '',
    element: <Navigate to={'endoso'} />,
  },
  {
    path: 'endoso',
    element: <EndorsementsPage title={'Endosos'} />,
  },
  {
    path: 'transporte-viajes',
    element: <TransportsPage title={'Transporte Mercaderías'} />,
  },
  
];
